module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/promo/5-e62b6b62981fb487d0de5f53282ddee7.jpg";